var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('toggle-button',{attrs:{"value":_vm.business.closed,"color":{
      checked: '#f44336',
      unchecked: '#4caf50',
      disabled: '#CCCCCC',
    },"width":60,"labels":{ checked: 'Closed', unchecked: 'Open' }},on:{"change":function($event){return _vm.onChangeEventHandler(_vm.business, _vm.closed)}},model:{value:(_vm.closed),callback:function ($$v) {_vm.closed=$$v},expression:"closed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }